import React, { memo } from 'react';
import _get from 'lodash.get';
import { AssetsSelector } from '@shootsta/common-react';

type ThumbnailAssetSelectorProps = {
  assetId?: string;
  videoAssetIds: string[];
  children: Node;
};

function ThumbnailAssetSelector({
  assetId,
  videoAssetIds,
  children
}: ThumbnailAssetSelectorProps) {
  return (
    <AssetsSelector assetIds={assetId ? [assetId] : videoAssetIds}>
      {(assets) => {
        const validAsset = assets.find((asset) => {
          if (asset === null) {
            return false;
          }

          // If any of the assets are void 0 it means we haven't resolved them yet
          if (!asset) {
            return true;
          }

          const originalFile = _get(asset, 'assetFiles.ORIGINAL');

          try {
            const { type } = JSON.parse(asset.metaData);

            return (
              originalFile.status !== 'MISSING' &&
              originalFile.status !== 'TRANSCODE_FAILED' &&
              originalFile.status !== 'ERROR' &&
              (type.includes('video/') || type.includes('image/'))
            );
          } catch (e: any) {
            return false;
          }
        });

        return children(validAsset);
      }}
    </AssetsSelector>
  );
}

export default memo<ThumbnailAssetSelectorProps>(ThumbnailAssetSelector);
